import React from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Footer from "./Footer";

const ResponsiblePlay = () => {
  return (
   <>
  <div className="terms-service">
    <Container>
      <Row className="justify-content-center">
        <Col md={10} lg={8}>
          <div className="terms-content mt-4 mb-5 p-4">
            <h1 className="text-center mb-4">🎯 Verantwoord spelen</h1>
            <p className="version-info text-center mb-4">
              Laatst bijgewerkt: 27 maart 2025
            </p>

            <p>Bij Firgoquast vinden we het belangrijk dat spelen leuk, veilig en gezond is. Wij bieden uitsluitend sociale casinospellen aan die gratis te spelen zijn en geen echt geld omvatten.</p>

            <h2>💡 Wat betekent verantwoord spelen?</h2>
            <p>Verantwoord spelen betekent dat je speelt voor je plezier – zonder dat het invloed heeft op je dagelijks leven, financiën of relaties.</p>
            <p>Ook al zijn onze spellen geen kansspelen, is het nog steeds belangrijk om gezonde speelgewoonten te behouden.</p>

            <h2>✅ Onze principes voor verantwoord spelen:</h2>
            <ul>
              <li>🎮 Speel voor je plezier – niet om problemen op te lossen</li>
              <li>🧘 Neem pauzes – speel niet langdurig zonder onderbreking</li>
              <li>⏰ Stel tijdslimieten in – en houd je eraan</li>
              <li>👀 Wees bewust – herken tekenen van verslaving of dwang</li>
              <li>🔞 Het platform is uitsluitend voor gebruikers van 18 jaar en ouder</li>
            </ul>

            <h2>⚠️ Maak je je zorgen over je eigen of andermans speelgedrag?</h2>
            <p>Als je merkt dat spelen de overhand krijgt – zelfs bij gratis spellen – raden we aan om met iemand te praten.</p>
            <p>👉 Hjelpelinjen.no biedt gratis en anoniem advies aan iedereen in Noorwegen:</p>
            <p>🔗 <a href="http://www.hjelpelinjen.no" target="_blank" rel="noopener noreferrer">www.hjelpelinjen.no</a></p>
            <p>📞 800 800 40 (24/7 bereikbaar)</p>

            <h2>🔒 Veilig spelen op Firgoquast</h2>
            <ul>
              <li>Firgoquast biedt alleen gratis sociale casinospellen aan</li>
              <li>Er zijn geen inzetten, aankopen of mogelijkheden om echt geld te winnen</li>
              <li>Vooruitgang in het spel geeft geen voordeel in echt gokken</li>
            </ul>

            <h2>🧠 Heb je tips nodig?</h2>
            <ul>
              <li>Speel met vrienden – maak het sociaal</li>
              <li>Stel je eigen grenzen in: voor tijd en frequentie</li>
              <li>Onthoud: het is maar een spel, geen wedstrijd om te winnen</li>
            </ul>

            <h2>📩 Neem contact met ons op</h2>
            <p>Heb je vragen of hulp nodig?</p>
            <p>Firgoquast AS</p>
            <p>📧 meister@gmail.com</p>
            <p>📍 Dronning Eufemias gate 16, 0191 Oslo, Noorwegen</p>
            <p> +47 22 83 70 10</p>
          </div>
        </Col>
      </Row>
    </Container>
  </div>
  <Footer />
</>

  );
};

export default ResponsiblePlay;
